import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmptyResultDashboard from "./EmptyResultDashboard";

interface LineBarChartNoDataProps {
    title?: string;
    description?: string;
    height: number;
    hideFiltersButton?: boolean;
    openFilters?: () => void;
}

const ChartNoData = ({title, description, height, hideFiltersButton, openFilters} : LineBarChartNoDataProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ marginRight: '4px', width: '100%', display: 'flex', flexDirection: 'column', height:{height} }}>
            {title && 
                <>
                    <Typography variant="h2">{title}</Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: '400', marginTop: '10px' }}>{description}</Typography>
                </>
            }
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <EmptyResultDashboard
                    title={t("screens.dashboarding.dataUnavailable")}
                    subtitle={t("screens.dashboarding.dataUnavailableText")}
                    buttonText={hideFiltersButton ? undefined : t("components.filters.filters")}
                    action={openFilters}
                />
            </Box>
        </Box>
    )
}

export default ChartNoData;
